const PUSH_PROMPT_LATER_SESSION_KEY = 'gb-ticket:push-prompt-later';
const PUSH_PROMPT_DECLINED_DEVICE_KEY = 'gb-ticket:push-prompt-declined-device';

export function isPushPromptLaterDismissed(): boolean {
  try {
    return sessionStorage.getItem(PUSH_PROMPT_LATER_SESSION_KEY) === '1';
  } catch {
    return false;
  }
}

export function dismissPushPromptForSession(): void {
  try {
    sessionStorage.setItem(PUSH_PROMPT_LATER_SESSION_KEY, '1');
  } catch {
    // ignore
  }
}

export function clearPushPromptLaterDismissed(): void {
  try {
    sessionStorage.removeItem(PUSH_PROMPT_LATER_SESSION_KEY);
  } catch {
    // ignore
  }
}

export function isPushPromptDeclinedOnDevice(): boolean {
  try {
    return localStorage.getItem(PUSH_PROMPT_DECLINED_DEVICE_KEY) === '1';
  } catch {
    return false;
  }
}

export function declinePushPromptOnDevice(): void {
  try {
    localStorage.setItem(PUSH_PROMPT_DECLINED_DEVICE_KEY, '1');
  } catch {
    // ignore
  }
}

export function clearPushPromptDeclinedOnDevice(): void {
  try {
    localStorage.removeItem(PUSH_PROMPT_DECLINED_DEVICE_KEY);
  } catch {
    // ignore
  }
}
